import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import Background from './Background';
import BootstrapSidebar from './BootstrapSidebar';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';
import { useState, useEffect } from 'react';
import { getDataForPropertiesByMonth } from './Utils';
import { useTranslation } from 'react-i18next';

const Main = () => {
    const [cookies, setCookie] = useCookies(['user']);
    const [chartData,setChartData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [pieData,setPieData] = useState([12,4,5,6]);
    const [graphData,setGraphData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [commercialGraphData,setCommercialGraphData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [homeGraphData,setHomeGraphData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [apartmentGraphData,setApartmentGraphData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [coWorkingSpaceGraphData,setCoWorkingSpaceGraphData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [warehouseGraphData,setWarehouseGraphData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [landGraphData,setLandGraphData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [selectedYear, setSelectedYear] = useState(2022);
    const [currentYear,setCurrentYear] = useState(2022);
    ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
    const years = Array.from({ length: currentYear - 1900 + 1 }, (_, index) => currentYear - index);
    const { t, i18n } = useTranslation();

    const handleYearChange = (e=null) => {
        
        var data = new FormData();
        
        data.append("id",11);
        if(e != null) {
            setSelectedYear(parseInt(e.target.value));
            data.append("year",parseInt(e.target.value));
        } else {
            data.append("year",2022);
        }
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_dashboard_data', {
            method: 'POST',
            body: data
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
                setChartData(data.data);
                var dataArray = [];
                dataArray.push(data.data.number_of_commercial);
                dataArray.push(data.data.number_of_home);
                dataArray.push(data.data.number_of_apartment);
                dataArray.push(data.data.number_of_coworking_space);
                dataArray.push(data.data.number_of_warehouse);
                dataArray.push(data.data.number_of_land);
                setPieData(dataArray);

                var graphDataArray = [0,0,0,0,0,0,0,0,0,0,0,0];
                var commercialGraphDataArray = [0,0,0,0,0,0,0,0,0,0,0,0];
                var homeGraphDataArray = [0,0,0,0,0,0,0,0,0,0,0,0];
                var apartmentGraphDataArray = [0,0,0,0,0,0,0,0,0,0,0,0];
                var coWorkingSpaceGraphDataArray = [0,0,0,0,0,0,0,0,0,0,0,0];
                var warehouseGraphDataArray = [0,0,0,0,0,0,0,0,0,0,0,0];
                var landGraphDataArray = [0,0,0,0,0,0,0,0,0,0,0,0];
                
                graphDataArray = getDataForPropertiesByMonth(data.data.number_of_properties_by_month);
                commercialGraphDataArray = getDataForPropertiesByMonth(data.data.number_of_commercial_by_month);
                homeGraphDataArray = getDataForPropertiesByMonth(data.data.number_of_home_by_month);
                apartmentGraphDataArray = getDataForPropertiesByMonth(data.data.number_of_apartment_by_month);
                coWorkingSpaceGraphDataArray = getDataForPropertiesByMonth(data.data.number_of_coworking_space_by_month);
                warehouseGraphDataArray = getDataForPropertiesByMonth(data.data.number_of_warehouse_by_month);
                landGraphDataArray = getDataForPropertiesByMonth(data.data.number_of_land_by_month);

                setGraphData(graphDataArray);
                setCommercialGraphData(commercialGraphDataArray);
                setHomeGraphData(homeGraphDataArray);
                setApartmentGraphData(apartmentGraphDataArray);
                setCoWorkingSpaceGraphData(coWorkingSpaceGraphDataArray);
                setWarehouseGraphData(warehouseGraphDataArray);
                setLandGraphData(landGraphDataArray);

            } else if(data.response_code == 404) {
                setChartData(null);
            }
         });
    };

    useEffect(() => {
        const abortController = new AbortController();
        const tempYear = new Date().getFullYear();
        setCurrentYear(tempYear);
        setSelectedYear(currentYear);
        handleYearChange(null);
       },[]);

    const options = {
        indexAxis: 'y',
        elements: {
          bar: {
            borderWidth: 2,
          },
        },
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: t("new_properties_posted_by_month"),
          },
        },
    };
      
    const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August','September','October','November','December'];
      
    const data2 = {
        labels,
        datasets: [
          {
            label: t("number_of_properties"),
            data: graphData,
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 0, 0, 0.5)',
          },
          {
            label: t("number_of_commercial"),
            data: commercialGraphData,
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
          },
          {
            label: t("number_of_home"),
            data: homeGraphData,
            borderColor: 'rgba(54, 162, 235, 1)',
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
          },
          {
            label: t("number_of_apartment"),
            data: apartmentGraphData,
            borderColor: 'rgba(255, 206, 86, 1)',
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
          },
          {
            label: t("number_of_coworking_space"),
            data: coWorkingSpaceGraphData,
            borderColor: 'rgba(75, 192, 192, 1)',
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
          },
          {
            label: t("number_of_warehouse"),
            data: warehouseGraphData,
            borderColor: 'rgba(153, 102, 255, 1)',
            backgroundColor: 'rgba(153, 102, 255, 0.2)',
          },
          {
            label: t("number_of_land"),
            data: landGraphData,
            borderColor: 'rgba(255, 159, 64, 1)',
            backgroundColor: 'rgba(255, 159, 64, 0.2)',
          },
        ],
      };

    var data1 = {
    labels: [t("commercial"), t("home"), t("apartment"), t("coworking_space"), t("warehouse"), t("land")],
    datasets: [
        {
        label: t("types_of_properties"),
        data: pieData,
        backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
        },
    ],
    };

    return (
        <div className="content">
          <div className="row justify-content-center">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 className="heading" style={{ color:"white", marginTop:"50px" }}>{t("dashboard")}</h4>
                    
                    {/* Stats Cards Row - Overlapping with orange background */}
                    <div className="row g-4" style={{ marginTop: "40px", position: "relative", zIndex: "10" }}>
                        {/* Properties Card */}
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                            <div className="card h-100" style={{ 
                                borderRadius: "12px", 
                                border: "none", 
                                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                                background: "linear-gradient(135deg, #FF4500 0%, #FF6B35 100%)",
                                color: "white",
                                transform: "translateY(-60px)",
                                marginBottom: "-60px",
                                minHeight: "240px"
                            }}>
                                <div className="card-body p-4" style={{ minHeight: "200px", display: "flex", flexDirection: "column" }}>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div>
                                            <h6 className="card-title text-white-50 mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>
                                                {t("properties")}
                                            </h6>
                                            <h2 className="mb-0" style={{ fontWeight: "700", fontSize: "32px" }}>
                                                {chartData != null ? chartData.number_of_properties : 0}
                                            </h2>
                                        </div>
                                        <div style={{ fontSize: "24px", opacity: "0.7" }}>🏠</div>
                                    </div>
                                    <div className="d-flex gap-2 mb-3">
                                        <span style={{ 
                                            padding: "4px 12px", 
                                            backgroundColor: "rgba(255,255,255,0.2)", 
                                            borderRadius: "20px", 
                                            fontSize: "12px",
                                            fontWeight: "500"
                                        }}>
                                            {t("sale")} {chartData != null ? chartData.number_of_properties_for_sale : 0}
                                        </span>
                                        <span style={{ 
                                            padding: "4px 12px", 
                                            backgroundColor: "rgba(255,255,255,0.2)", 
                                            borderRadius: "20px", 
                                            fontSize: "12px",
                                            fontWeight: "500"
                                        }}>
                                            {t("rent")} {chartData != null ? chartData.number_of_properties_for_rent : 0}
                                        </span>
                                    </div>
                                    <div style={{ height: "40px", opacity: "0.3", marginTop: "auto", overflow: "hidden" }}>
                                        <img src="/images/graph_orange.png" className="img-fluid" style={{ height: "100%", width: "100%", objectFit: "cover" }} alt="graph" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Users Card */}
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                            <div className="card h-100" style={{ 
                                borderRadius: "12px", 
                                border: "none", 
                                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                                background: "linear-gradient(135deg, #007bff 0%, #4dabf7 100%)",
                                color: "white",
                                transform: "translateY(-60px)",
                                marginBottom: "-60px",
                                minHeight: "240px"
                            }}>
                                <div className="card-body p-4" style={{ minHeight: "200px", display: "flex", flexDirection: "column" }}>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div>
                                            <h6 className="card-title text-white-50 mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>
                                                {t("users")}
                                            </h6>
                                            <h2 className="mb-0" style={{ fontWeight: "700", fontSize: "32px" }}>
                                                {chartData != null ? chartData.number_of_users : 0}
                                            </h2>
                                        </div>
                                        <div style={{ fontSize: "24px", opacity: "0.7" }}>👥</div>
                                    </div>
                                    <div style={{ height: "40px", opacity: "0.3", marginTop: "auto", overflow: "hidden" }}>
                                        <img src="/images/graph_blue.png" className="img-fluid" style={{ height: "100%", width: "100%", objectFit: "cover" }} alt="graph" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Messages Card */}
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                            <div className="card h-100" style={{ 
                                borderRadius: "12px", 
                                border: "none", 
                                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                                background: "linear-gradient(135deg, #28a745 0%, #51cf66 100%)",
                                color: "white",
                                transform: "translateY(-60px)",
                                marginBottom: "-60px",
                                minHeight: "240px"
                            }}>
                                <div className="card-body p-4" style={{ minHeight: "200px", display: "flex", flexDirection: "column" }}>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div>
                                            <h6 className="card-title text-white-50 mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>
                                                {t("messages")}
                                            </h6>
                                            <h2 className="mb-0" style={{ fontWeight: "700", fontSize: "32px" }}>
                                                {chartData != null ? chartData.messages : 0}
                                            </h2>
                                        </div>
                                        <div style={{ fontSize: "24px", opacity: "0.7" }}>💬</div>
                                    </div>
                                    <div style={{ height: "40px", opacity: "0.3", marginTop: "auto", overflow: "hidden" }}>
                                        <img src="/images/graph_orange.png" className="img-fluid" style={{ height: "100%", width: "100%", objectFit: "cover" }} alt="graph" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Careers Card */}
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                            <div className="card h-100" style={{ 
                                borderRadius: "12px", 
                                border: "none", 
                                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                                background: "linear-gradient(135deg, #6f42c1 0%, #9775fa 100%)",
                                color: "white",
                                transform: "translateY(-60px)",
                                marginBottom: "-60px",
                                minHeight: "240px"
                            }}>
                                <div className="card-body p-4" style={{ minHeight: "200px", display: "flex", flexDirection: "column" }}>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div>
                                            <h6 className="card-title text-white-50 mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>
                                                {t("careers")}
                                            </h6>
                                            <h2 className="mb-0" style={{ fontWeight: "700", fontSize: "32px" }}>
                                                {chartData != null ? chartData.careers : 0}
                                            </h2>
                                        </div>
                                        <div style={{ fontSize: "24px", opacity: "0.7" }}>💼</div>
                                    </div>
                                    <div style={{ height: "40px", opacity: "0.3", marginTop: "auto", overflow: "hidden" }}>
                                        <img src="/images/graph_green.png" className="img-fluid" style={{ height: "100%", width: "100%", objectFit: "cover" }} alt="graph" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Charts Section */}
                    <div className="row g-4" style={{ marginTop: "30px" }}>
                        {/* Pie Chart Card */}
                        <div className="col-lg-5">
                            <div className="card h-100" style={{ 
                                borderRadius: "12px", 
                                border: "none", 
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                backgroundColor: "white"
                            }}>
                                <div className="card-body p-4">
                                    <div className="mb-4">
                                        <h5 className="card-title mb-1" style={{ color: "#333", fontWeight: "600" }}>
                                            <span style={{ color: "#FF4500" }}>{t("total")}</span> {t("properties")}
                                        </h5>
                                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Property type distribution</p>
                                    </div>
                                    <div style={{ height: "300px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Doughnut data={data1} options={{ maintainAspectRatio: false }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Bar Chart Card */}
                        <div className="col-lg-7">
                            <div className="card h-100" style={{ 
                                borderRadius: "12px", 
                                border: "none", 
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                backgroundColor: "white"
                            }}>
                                <div className="card-body p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div>
                                            <h5 className="card-title mb-1" style={{ color: "#333", fontWeight: "600" }}>
                                                <span style={{ color: "#FF4500" }}>| {t("graph")}</span> {t("by_year")}
                                            </h5>
                                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Monthly property trends</p>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label htmlFor="year" style={{ fontSize: "14px", color: "#666", margin: 0 }}>
                                                {t("select_a_year")}:
                                            </label>
                                            <select 
                                                id="year" 
                                                value={selectedYear} 
                                                onChange={handleYearChange}
                                                className="form-select form-select-sm"
                                                style={{ 
                                                    width: "auto", 
                                                    minWidth: "100px",
                                                    fontSize: "14px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "6px"
                                                }}
                                            >
                                                {years.map(year => (
                                                    <option key={year} value={year}>{year}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div style={{ height: "300px" }}>
                                        <Bar options={{...options, maintainAspectRatio: false}} data={data2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;